import { CreateDoctorCommunication } from 'domain/usecases/surgical-pendency/create-doctor-communication'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteCreateDoctorCommunication
  implements CreateDoctorCommunication
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}

  create(
    params: CreateDoctorCommunication.Params
  ): Promise<CreateDoctorCommunication.Model> {
    return this.surgicalPendencyRepository.createDoctorCommunication(params)
  }
}
